import { jsx as _jsx } from "react/jsx-runtime";
import App from "./App";
import { createRoot } from "react-dom/client";
import "bootstrap/dist/css/bootstrap-reboot.min.css";
import "bootstrap/dist/css/bootstrap-grid.min.css";
import "bootstrap/dist/css/bootstrap-utilities.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "./index.css";
import "./assets/css/mobile.css";
// Force dropdowns to always open downward
document.addEventListener('DOMContentLoaded', function () {
    // Simple approach: Force all dropdown menus to open downward
    var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                var target = mutation.target;
                if (target.classList.contains('dropdown-menu') && target.classList.contains('show')) {
                    target.style.top = '100%';
                    target.style.bottom = 'auto';
                    target.style.transform = 'none';
                }
            }
        });
    });
    // Observe all dropdown menus
    var dropdownMenus = document.querySelectorAll('.dropdown-menu');
    dropdownMenus.forEach(function (menu) {
        observer.observe(menu, { attributes: true, attributeFilter: ['class'] });
    });
    // Also handle clicks on dropdown toggles
    document.addEventListener('click', function (event) {
        var target = event.target;
        if (target.classList.contains('dropdown-toggle')) {
            setTimeout(function () {
                var dropdown = target.nextElementSibling;
                if (dropdown && dropdown.classList.contains('dropdown-menu')) {
                    dropdown.style.top = '100%';
                    dropdown.style.bottom = 'auto';
                    dropdown.style.transform = 'none';
                }
            }, 10);
        }
    });
});
var rootElement = document.getElementById("root");
var root = createRoot(rootElement);
root.render(_jsx(App, {})
// <StrictMode>
//   <App />
// </StrictMode>
);
